import styled from 'styled-components';
import { IonModal, isPlatform } from '@ionic/react';

export const SettingsModalStyled = styled(IonModal)`
  --height: calc(643px + var(--ion-safe-area-bottom));
  --width: ${isPlatform('desktop') && !isPlatform('android') && !isPlatform('ios') ? '460px' : '100%'};

  &::part(content) {
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
  }

  & .my-info {
    margin-top: 22px;
    margin-bottom: 16px;
  }
`;

export const SettingsCloseButton = styled.button`
  outline: none;
  position: absolute;
  top: 22px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  background: transparent;
  color: #1d201f;
  font-size: 27px;
`;

export const SettingsMenuList = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  & li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1d201f;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    padding: 19px 16px;

    border-bottom: 1px solid #eeeeee;
    cursor: pointer;

    &:first-child {
      border-top: 1px solid #eeeeee;
    }

    & ion-icon {
      --ionicon-stroke-width: 24px;
      font-size: 24px;
    }

    &:active {
      background: #f2f4f7;
    }

    &.disabled {
      cursor: default !important;
      color: #c1c1c1;

      ion-icon {
        color: #c1c1c1;
      }
    }
  }
`;
